import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("app_atkey");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.resolve(err);
  }
);

interface dataCreateUser {
  createUserData: any[];
  error: string;
  success: boolean;
  isLoading: boolean;
}

const initialState: dataCreateUser = {
  createUserData: [],
  error: "",
  success: false,
  isLoading: false,
};

const createUserDataSlice = createSlice({
  name: "createUserData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // هنگام ارسال درخواست
      .addCase(getcreateUserData.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(getcreateUserData.fulfilled, (state:any, action:any) => {
        state.isLoading = false;
        state.createUserData = action.payload;
        state.success = true;
      })
      .addCase(getcreateUserData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Something went wrong";
        state.success = false;
      })
      .addCase(addcreateUserData.fulfilled, (state, action) => {
        if (Array.isArray(state.createUserData)) {
          state.createUserData.push(action.payload);
        } else {
          console.error(
            "createUserData is not an array:",
            state.createUserData
          );
        }
      })

      .addCase(deletecreateUserData.fulfilled, (state, action) => {
        state.createUserData = state.createUserData.filter(
          (data: any) => data.user_id !== action.payload.user_id
        ); // حذف createUserData
      })
      // عملیات به‌روزرسانی createUserData
      .addCase(updatecreateUserData.fulfilled, (state, action) => {
        const index = state.createUserData.findIndex(
          (data) => data.user_id === action.payload.user_id
        );
        if (index !== -1) {
          state.createUserData[index] = action.payload; // به‌روزرسانی اطلاعات createUserData
        }
      });
  },
});

// ایجاد Thunks برای عملیات مختلف

// Thunk برای دریافت داده‌ها از سرور
export const getcreateUserData = createAsyncThunk(
  "createUserData/getcreateUserData",
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(url);
      return response; // داده‌ها را از پاسخ axios استخراج می‌کنیم
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addcreateUserData = createAsyncThunk(
  "createUserData/addData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.havirkesht.ir/users/admin/",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error adding data user:", error);
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Network Error";
        return rejectWithValue({
          message,
          status: error.response?.status,
        });
      }
      return rejectWithValue({
        message: "An unknown error occurred",
      });
    }
  }
);

// Thunk برای حذف DataFactory
export const deletecreateUserData = createAsyncThunk(
  "datafactory/deleteData",
  async (user_id: string, { rejectWithValue }) => {
    try {
      await axios.delete(`https://api.havirkesht.ir/users/${user_id}`);
      return { user_id }; // فقط شناسه DataFactory را بر می‌گردانیم
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

// Thunk برای به‌روزرسانی اطلاعات DataFactory
export const updatecreateUserData = createAsyncThunk(
  "datafactory/updateData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://api.havirkesht.ir/users/${data.user_id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// صادرات اکشن‌ها و reducer
export default createUserDataSlice.reducer;
